import { observer } from "mobx-react";
import Report from "../../../components/report/report";
import { REPORT_TYPES } from "../../../services/api/report-service";
import useDashboardTranslation from "../../../dashboard-translation/hooks/dashboard-translation-hook";

interface IProps {
    type: REPORT_TYPES
}

const ReportWidget: React.FC<IProps> = observer(({ type }) => {
    const { getTranslation } = useDashboardTranslation();

    const getReportFilters = () => {
        const filters: { [key: string]: string } = {};
        const url = new URL(window.location.href);
        
        url.searchParams.forEach((value, key) => {
            filters[key] = value;
        });
    
        return filters;
    }

    return (
        <Report
            type={type}
            title={getTranslation('REPORT','dashboard-general')}
            getReportFilters={getReportFilters}
        />
    );
});

export default ReportWidget;
